import React, { Suspense, lazy } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import LoadingComponent from './components/LoadingComponent';

import Home from './pages/home/Home'
const Explore = lazy(() => import('./pages/explore/Explore'));
const Details = lazy(() => import('./pages/details/Details'));
const Anime = lazy(() => import('./pages/anime/Anime'));
const Search = lazy(() => import('./pages/search/Search'));

function App() {
  return (
    <>
      <HashRouter>
        <Header />
        <Suspense fallback={<LoadingComponent />}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/explore/:mediaType" element={<Explore />} />
            <Route path="/:mediaType/:id" element={<Details />} />
            <Route path="/explore/search/:searchQuery" element={<Search />} />
            <Route path="/explore/anime" element={<Anime />} />
          </Routes>
        </Suspense>
        <Footer />
      </HashRouter>
    </>
  );
}

export default App;

// import Home from './pages/home/Home'; // Directly import Home component

// // Lazy load other components
// const Explore = lazy(() => import('./pages/explore/Explore'));
// const Details = lazy(() => import('./pages/details/Details'));
// const Anime = lazy(() => import('./pages/anime/Anime'));
// const Search = lazy(() => import('./pages/search/Search'));

// function App() {
//   return (
//     <>
//       <BrowserRouter>
//         <Header />
//         <Routes>
//           <Route path="/" element={<Navigate to="/home" replace />} />
//           <Route path="/home" element={<Home />} /> {/* Home component is not lazy-loaded */}
//           <Route
//             path="/explore/:mediaType"
//             element={
//               <Suspense fallback={<LoadingComponent />}>
//                 <Explore />
//               </Suspense>
//             }
//           />
//           <Route
//             path="/:mediaType/:id"
//             element={
//               <Suspense fallback={<LoadingComponent />}>
//                 <Details />
//               </Suspense>
//             }
//           />
//           <Route
//             path="/explore/search/:searchQuery"
//             element={
//               <Suspense fallback={<LoadingComponent />}>
//                 <Search />
//               </Suspense>
//             }
//           />
//           <Route
//             path="/explore/anime"
//             element={
//               <Suspense fallback={<LoadingComponent />}>
//                 <Anime />
//               </Suspense>
//             }
//           />
//         </Routes>
//         <Footer />
//       </BrowserRouter>


//     </>
//   );
// }

// export default App;

// import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
// import './App.css';
// import Home from './pages/home/Home';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import Explore from './pages/explore/Explore';
// import Details from './pages/details/Details';
// import Anime from './pages/anime/Anime';
// import Search from './pages/search/Search';

// function App() {
//   return (
//     <>
//       <BrowserRouter>
//       <Header/>
//         <Routes>
//           <Route path="/" element={<Navigate to="/home" replace />} />
//           <Route path="/home" element={<Home />} />
//           <Route path="/explore/:mediaType" element={<Explore />} />
//           <Route path="/:mediaType/:id" element={<Details />} />
//           <Route path="/explore/search/:searchQuery" element={<Search />} />
//           <Route path="/explore/anime" element={<Anime />} />
//         </Routes>
//         <Footer/>
//       </BrowserRouter>
//     </>
//   );
// }

// export default App;
